var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1400_18044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4286 16H10.7124C8.57767 16 5.86887 15.9698 3.85161 15.7894C2.19884 15.6408 1.80391 15.3941 1.39507 15.0341C0.219862 14.0062 0.0337079 11.1489 0.00326205 8.77495C-0.00108735 8.28321 -0.00108735 7.78392 0.00326205 7.29134C0.0310982 4.88887 0.214643 1.99885 1.39072 0.962501C1.80826 0.604185 2.20232 0.358315 3.85161 0.212304C5.85147 0.0310484 8.56897 0.00503488 10.7124 0H12.0033H13.2907C15.4341 0 18.1498 0.0302092 20.1506 0.210626C21.8033 0.357476 22.1948 0.603346 22.6071 0.961662C23.7745 1.98458 23.9632 4.80915 23.9989 7.15624C24.0067 7.71511 24.0067 8.28153 23.9989 8.84041C23.965 11.19 23.7762 14.0121 22.6071 15.0325C22.1991 15.3916 21.8077 15.6383 20.1506 15.7877C18.1333 15.969 15.4254 15.995 13.2907 15.9983L12.4286 16ZM9.65458 4.67153V11.5391L15.7098 7.99958L9.65458 4.67153Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1400_18044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube-logo.bba4eef2f328b14ad38ee24e48cf1177.svg";
export { ForwardRef as ReactComponent };